import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, LeafIcon } from 'lucide-react';
const Hero = () => {
  return <section className="relative bg-white overflow-hidden" data-id="element-293">
      {/* Background pattern */}
      <div className="absolute inset-0 z-0" data-id="element-294">
        <div className="absolute inset-0 bg-[#f8f9f4]" data-id="element-295"></div>
        <div className="absolute right-0 top-0 h-full w-1/2 bg-[#f0f7eb] clip-path-polygon" data-id="element-296"></div>
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-[#e8f5e9] opacity-50 blur-3xl" style={{
        filter: 'blur(60px)'
      }} data-id="element-297"></div>
        <div className="absolute top-1/2 -left-16 w-48 h-48 rounded-full bg-[#e8f5e9] opacity-50 blur-3xl" style={{
        filter: 'blur(60px)'
      }} data-id="element-298"></div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-299">
        <div className="grid md:grid-cols-12 gap-8 pt-12 pb-20 md:py-24 items-center" data-id="element-300">
          {/* Content */}
          <div className="md:col-span-6 lg:col-span-5 flex flex-col justify-center relative z-10" data-id="element-301">
            <div className="inline-flex items-center px-4 py-2 bg-[#e8f5e9] text-[#2e7d32] text-sm font-medium rounded-full mb-6 self-start" data-id="element-302">
              <LeafIcon className="h-4 w-4 mr-2" data-id="element-303" />
              <span data-id="element-304">100% Pure Essential Oils</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" data-id="element-305">
              Nature's Essence
              <span className="block mt-2 text-[#2e7d32]" data-id="element-306">Bottled for You</span>
            </h1>
            <p className="text-lg text-gray-600 mt-6 mb-8 leading-relaxed max-w-lg" data-id="element-307">
              Experience the therapeutic benefits of premium essential oils
              sourced directly from Kenya's rich landscapes and around the
              world.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-308">
              <Link to="/products" className="bg-[#2e7d32] hover:bg-[#1b5e20] text-white px-8 py-3.5 rounded-lg font-medium transition-colors duration-300 inline-flex items-center justify-center shadow-md group" data-id="element-309">
                Shop Collection
                <ArrowRightIcon className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-310" />
              </Link>
              <Link to="/about" className="bg-white text-[#2e7d32] border border-[#2e7d32] hover:bg-[#f0f7eb] px-8 py-3.5 rounded-lg font-medium transition-colors duration-300 inline-flex items-center justify-center" data-id="element-311">
                Learn More
              </Link>
            </div>
            {/* Testimonial strip */}
            <div className="bg-white rounded-xl shadow-md p-4 flex items-center max-w-md" data-id="element-312">
              <div className="flex -space-x-2 mr-3" data-id="element-313">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=40&auto=format&fit=crop" alt="Customer" className="w-8 h-8 rounded-full border-2 border-white" onError={e => {
                e.currentTarget.src = 'https://ui-avatars.com/api/?name=Customer&background=e8f5e9&color=2e7d32&size=40';
              }} data-id="element-314" />
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=40&auto=format&fit=crop" alt="Customer" className="w-8 h-8 rounded-full border-2 border-white" onError={e => {
                e.currentTarget.src = 'https://ui-avatars.com/api/?name=User&background=e8f5e9&color=2e7d32&size=40';
              }} data-id="element-315" />
                <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=40&auto=format&fit=crop" alt="Customer" className="w-8 h-8 rounded-full border-2 border-white" onError={e => {
                e.currentTarget.src = 'https://ui-avatars.com/api/?name=Client&background=e8f5e9&color=2e7d32&size=40';
              }} data-id="element-316" />
              </div>
              <div data-id="element-317">
                <p className="text-sm font-medium text-gray-900" data-id="element-318">
                  Trusted by 10,000+ customers
                </p>
                <div className="flex mt-1" data-id="element-319">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-3 h-3 text-yellow-400 fill-current" viewBox="0 0 24 24" data-id="element-320">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-321" />
                    </svg>)}
                </div>
              </div>
            </div>
          </div>
          {/* Image grid */}
          <div className="md:col-span-6 lg:col-span-7 relative" data-id="element-322">
            <div className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-323">
              <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-lg" data-id="element-324">
                <img src="https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?q=80&w=600&auto=format&fit=crop" alt="Essential oils" className="w-full h-full object-cover" onError={e => {
                e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop';
              }} data-id="element-325" />
              </div>
              <div className="grid grid-rows-2 gap-4 md:gap-6" data-id="element-326">
                <div className="rounded-2xl overflow-hidden shadow-lg bg-[#f0f7eb] p-6 flex flex-col justify-center" data-id="element-327">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center mb-4" data-id="element-328">
                    <div className="w-6 h-6 rounded-full bg-[#2e7d32]" data-id="element-329"></div>
                  </div>
                  <h3 className="font-semibold text-[#2e7d32]" data-id="element-330">100% Pure</h3>
                  <p className="text-sm text-gray-700 mt-1" data-id="element-331">
                    Ethically sourced from nature
                  </p>
                </div>
                <div className="rounded-2xl overflow-hidden shadow-lg" data-id="element-332">
                  <img src="https://images.unsplash.com/photo-1564515963098-cb5ee5c1f4f7?q=80&w=600&auto=format&fit=crop" alt="Essential oil ingredients" className="w-full h-full object-cover" onError={e => {
                  e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop';
                }} data-id="element-333" />
                </div>
              </div>
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-10 left-1/2 transform -translate-x-1/2 bg-white rounded-xl shadow-xl p-4 w-full max-w-sm" data-id="element-334">
              <div className="flex items-center justify-between" data-id="element-335">
                <div className="flex items-center space-x-4" data-id="element-336">
                  <div className="w-10 h-10 rounded-full bg-[#e8f5e9] flex items-center justify-center" data-id="element-337">
                    <LeafIcon className="h-5 w-5 text-[#2e7d32]" data-id="element-338" />
                  </div>
                  <div data-id="element-339">
                    <p className="font-medium text-gray-900" data-id="element-340">Premium Quality</p>
                    <p className="text-sm text-gray-500" data-id="element-341">Kenyan sourced</p>
                  </div>
                </div>
                <Link to="/products" className="text-[#2e7d32] hover:text-[#1b5e20]" data-id="element-342">
                  <ArrowRightIcon className="h-5 w-5" data-id="element-343" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Trust badges */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-344">
        <div className="bg-white rounded-xl shadow-lg p-6 max-w-4xl mx-auto -mt-6 mb-12" data-id="element-345">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-346">
            <div className="flex items-center justify-center md:justify-start" data-id="element-347">
              <div className="w-3 h-3 rounded-full bg-[#2e7d32] mr-3" data-id="element-348"></div>
              <span className="text-sm font-medium" data-id="element-349">100% Natural</span>
            </div>
            <div className="flex items-center justify-center" data-id="element-350">
              <div className="w-3 h-3 rounded-full bg-[#2e7d32] mr-3" data-id="element-351"></div>
              <span className="text-sm font-medium" data-id="element-352">Ethically Sourced</span>
            </div>
            <div className="flex items-center justify-center md:justify-end" data-id="element-353">
              <div className="w-3 h-3 rounded-full bg-[#2e7d32] mr-3" data-id="element-354"></div>
              <span className="text-sm font-medium" data-id="element-355">Quality Tested</span>
            </div>
          </div>
        </div>
      </div>
      <style jsx data-id="element-356">{`
        .clip-path-polygon {
          clip-path: polygon(100% 0, 100% 100%, 0 100%, 30% 0);
        }
      `}</style>
    </section>;
};
export default Hero;